import React, { useState } from 'react';

import { DateRangePicker, LocalizationProvider, SingleInputDateRangeField } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';

import { MAX_RANGE_DAYS, getLatestReportDate } from '~/components/GHAParticipationReport/utils';

import type { Dayjs } from '~/services/TimeService';

import { OPPORTUNITY_HISTORY_DAYS } from './constants';

interface Props {
  value: [Dayjs, Dayjs];
  onChange: (value: [Dayjs, Dayjs]) => void;
}

// Same picker as the Customer demand tab.
export default function CompetitorOffersDateRange({ value, onChange }: Props) {
  const [rangeError, setRangeError] = useState<string | null>(null);
  const latest = getLatestReportDate();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateRangePicker
        value={value}
        onAccept={([start, end]) => {
          if (!start || !end) {
            return;
          }
          if (end.diff(start, 'day') >= MAX_RANGE_DAYS) {
            setRangeError(`Pick a range of ${MAX_RANGE_DAYS} days or fewer.`);
            return;
          }
          setRangeError(null);
          onChange([start, end]);
        }}
        calendars={1}
        closeOnSelect={false}
        format="DD/MM/YYYY"
        minDate={latest.subtract(OPPORTUNITY_HISTORY_DAYS - 1, 'day')}
        maxDate={latest}
        localeText={{ okButtonLabel: 'Confirm' }}
        slots={{ field: SingleInputDateRangeField }}
        slotProps={{
          textField: {
            label: 'Enter a date range',
            size: 'small',
            error: Boolean(rangeError),
            helperText: rangeError ?? 'Only used for Opportunities and Searching from',
            sx: { width: 330 },
          },
          actionBar: { actions: ['cancel', 'accept'] },
        }}
      />
    </LocalizationProvider>
  );
}
